module.exports = __webpack_public_path__ + "img/lt_sign_in.e74d53cb.png";